const CONFIG = {
  BASE_URL: 'https://lost-and-found-api-nu.vercel.app',
  BASE_IMAGE_URL: 'https://lost-and-found-image-api.vercel.app/image/',
};

export default CONFIG;
